import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useNavigate, useLocation } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
    } else {
      const role = data.user.app_metadata?.role || 'user';

      // Get the location user attempted to visit before login
      const redirectTo = location.state?.from?.pathname;

      if (role === 'admin') {
        navigate('/admin');
      } else if (redirectTo) {
        navigate(redirectTo, { replace: true });
      } else {
        navigate('/dashboard');
      }
    }
  };

  return (
    <main className="min-h-screen bg-gradient-to-tl from-indigo-50 to-blue-100 flex items-center justify-center p-6">
      <section className="w-full max-w-md bg-white p-8 rounded-xl shadow-md">
        <h1 className="text-3xl font-extrabold text-indigo-800 text-center mb-6">Welcome Back</h1>
        {error && <div className="text-red-600 mb-4 text-center">{error}</div>}
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-gray-700 font-semibold mb-2">Email Address</label>
            <input
              type="email"
              className="w-full border border-gray-300 rounded px-4 py-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-2">Password</label>
            <input
              type="password"
              className="w-full border border-gray-300 rounded px-4 py-2"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="flex justify-between text-sm text-indigo-600 font-medium">
            <a href="#" className="hover:underline">Forgot Password?</a>
            <a href="/register" className="hover:underline">Create Account</a>
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-700 hover:bg-indigo-800 text-white font-bold py-3 rounded-xl transition"
          >
            Log In
          </button>
        </form>
      </section>
    </main>
  );
};

export default Login;
